<template>
  <div v-if="showDropDown" class="float-left header-menu-contain">
    <!-- Activator link -->
    <a
      href="#"
      class="activator d-block"
      @click.stop.prevent="showDropdown = true"
    >
      <object
        class="search-icon icon-hamburger"
        :data="menuSvg"
        type="image/svg+xml"
      ></object>
    </a>

    <!-- Drop down link -->
    <transition name="zoom">
      <div class="dropdown" v-if="showDropdown">
        <a href="#" class="close" @click.stop.prevent="showDropdown = false">
          <span class="icon-close"></span>
        </a>
        <ul>
          <li>
            <img :src="calendarIcon" />
            <router-link to="/">Calendar</router-link>
          </li>
          <li>
            <img :src="clientsIcon" />
            <router-link to="/contacts">Contacts</router-link>
          </li>
        </ul>
      </div>
    </transition>
  </div>
</template>

<script>
import { permissionMixin } from "@/mixins/permissionMixin";

export default {
  mixins: [permissionMixin],
  data() {
    return {
      showDropdown: false, // Show drop down or not
      menuSvg: require("../../../assets/svg/menu-icon.svg"),
      calendarIcon: require("../../../assets/img/m_calendar.png"),
      clientsIcon: require("../../../assets/img/m_clients.png"),
      othersIcon: require("../../../assets/img/m_others.png")
    };
  },
  created() {
    window.addEventListener("click", () => {
      this.showDropdown = false;
    });
  }
};
</script>

<style scoped>
/* a.activator {
  position: absolute;
} */
.icon-hamburger {
  top: 10px;
  width: 26px;
  margin-right: 10px;
}
div.dropdown {
  z-index: 99990;
  background-color: #f8f8f8;
  position: absolute;
  border: 1px solid #d0d0d0;
  border-radius: 5px;
  box-shadow: 1px 1px 5px lightgray;
  top: 49px;
  left: -5px;
}

div.dropdown ul {
  margin: 0px;
  padding: 0px;
}

a.close {
  position: absolute;
  right: 6px;
  padding: 6px;
  color: black;
  font-weight: 600;
  top: 8px;
}

div.dropdown ul li {
  list-style: none;
  margin: 10px;
  padding-right: 30px;
  padding-bottom: 5px;
  display: flex;
  align-items: center;
}

div.dropdown ul li img {
  height: 20px;
  margin-right: 10px;
}

div.dropdown ul li a {
  font-size: 20px;
  color: black;
  font-weight: 540;
}

div.dropdown ul li:not(:last-of-type) {
  border-bottom: 1px solid #d0d0d0;
}

.zoom-enter-active {
  animation: zoomIn 0.5s ease-in-out;
}

.zoom-leave-active {
  animation: zoomOut 0.5s ease-in-out;
}

@keyframes zoomIn {
  from {
    opacity: 0;
  }

  50% {
    opacity: 1;
  }
}

@keyframes zoomOut {
  from {
    opacity: 1;
  }

  50% {
    opacity: 0;
    transform: scale3d(0.3, 0.3, 0.3);
  }

  to {
    opacity: 0;
  }
}
</style>
